export const getDuration = (startTime: number, endTime: number) => {
	const start = parseFloat(startTime.toString());
	const end = parseFloat(endTime.toString());
	const floor = Math.floor;
	const duration = end - start;

	let time = duration;
	const hour = floor(time / 3600);
	time -= hour * 3600;
	const minute = floor(time / 60);
	time -= floor(minute * 60);
	const second = floor(time);
	const millisecond = Math.round((time - second) * 1000);

	return {
		seconds: duration,
		pretty: [
			hour.toString().padStart(2, '0'),
			':',
			minute.toString().padStart(2, '0'),
			':',
			second.toString().padStart(2, '0'),
			'.',
			millisecond.toString().padStart(3, '0'),
		].join(''),
	};
};
